module.exports = "https://files.cnvos.lb.djnd.si/static/images/menu-logo-hires.png?aedc2fc2830f89ab45ccd18ee27e2cf2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-logo-hires.png
// module id = 130
// module chunks = 1 2